import { render, staticRenderFns } from "./Runway.vue?vue&type=template&id=4b8df578&scoped=true&"
import script from "./Runway.vue?vue&type=script&lang=js&"
export * from "./Runway.vue?vue&type=script&lang=js&"
import style0 from "./Runway.vue?vue&type=style&index=0&id=4b8df578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8df578",
  null
  
)

export default component.exports